// 기본 호출: layer.openFn({ target: '.클래스명' });
// AJAX 호출: layer.openFn({ ajaxUrl: 'URL' });
// 닫기: layer.closeFn(callback);

document.addEventListener('DOMContentLoaded', () => {
    const calendar = (() => {
        const selector = '[data-fullcalendar]';

        const getCalendarElements = (scope = document) => {
            const elements = scope.matches?.(selector) ? [scope] : [];
            return elements.concat(Array.from(scope.querySelectorAll?.(selector) || []));
        };

        const getSelectedDateInput = (calendarEl) => {
            const localInput = calendarEl.parentElement?.querySelector('[data-calendar-selected]');
            const layerEl = calendarEl.closest('.layer');
            return localInput || layerEl?.querySelector('[data-calendar-selected]') || null;
        };

        const create = (calendarEl) => {
            if (!calendarEl || calendarEl._fullCalendar || typeof FullCalendar === 'undefined') return;

            const selectedDateInput = getSelectedDateInput(calendarEl);
            let selectedDate = selectedDateInput?.value || '';

            const instance = new FullCalendar.Calendar(calendarEl, {
                height: 'auto',
                contentHeight: 'auto',
                locale: 'ko',
                initialView: 'dayGridMonth',
                firstDay: 0,
                dayHeaders: false,
                showNonCurrentDates: true,
                fixedWeekCount: false,
                headerToolbar: { left: 'prev title next', center: '', right: '' },
                dateClick(info) {
                    selectedDate = info.dateStr;

                    calendarEl.querySelectorAll('.fc-day-selected').forEach((dayEl) => {
                        dayEl.classList.remove('fc-day-selected');
                    });
                    info.dayEl.classList.add('fc-day-selected');

                    if (selectedDateInput) selectedDateInput.value = selectedDate;

                    calendarEl.dispatchEvent(new CustomEvent('calendarDateChange', {
                        detail: { date: selectedDate }
                    }));
                },
                dayCellDidMount(info) {
                    if (info.el.dataset.date === selectedDate) {
                        info.el.classList.add('fc-day-selected');
                    }
                },
                dayCellContent(info) {
                    const dayNumber = info.dayNumberText.replace('일', '').replace('日', '');
                    return { html: `<em class="fc-daygrid-day-number">${dayNumber}</em>` };
                }
            });

            instance.render();
            calendarEl._fullCalendar = instance;
        };

        const initFn = (scope = document) => {
            getCalendarElements(scope).forEach(create);
        };

        const destroyFn = (scope = document) => {
            getCalendarElements(scope).forEach((calendarEl) => {
                calendarEl._fullCalendar?.destroy();
                calendarEl._fullCalendar = null;

                const selectedDateInput = getSelectedDateInput(calendarEl);
                if (selectedDateInput) selectedDateInput.value = '';
            });
        };

        return { initFn, destroyFn };
    })();

    const layer = (() => {
        const defaultOption = Object.freeze({
            target: '.layer',
            $target: null,
            ajaxUrl: undefined,
            ajaxCall: false,
            prevTarget: undefined,
            active: false,
            ajaxContainer: null
        });
        const bodyEl = document.body;
        let option = { ...defaultOption };

        const resolveElement = (target) => {
            if (typeof target === 'string') return document.querySelector(target);
            if (target?.jquery) return target[0];
            return target instanceof Element ? target : null;
        };

        const resetLayerMotion = (layerEl) => {
            layerEl.style.transition = '';
            layerEl.style.transform = '';
        };

        const closeFn = (callback) => {
            if (!option.active) return;

            const target = option.$target;
            calendar.destroyFn(target);
            target.querySelector('.layer__bg')?.remove();

            if (option.ajaxCall) {
                option.ajaxContainer?.remove();
            } else {
                target.style.display = 'none';
            }

            resetLayerMotion(target);
            const swipeTarget = target.querySelector('.layer__table-cell');
            if (swipeTarget) resetLayerMotion(swipeTarget);
            bodyEl.classList.remove('ovf');
            option = { ...defaultOption };

            if (typeof callback === 'function') callback();
        };

        const bindSwipeClose = (layerEl) => {
            if (!layerEl.classList.contains('layer--bottom')) return;

            const swipeTarget = layerEl.querySelector('.layer__table-cell');
            if (!swipeTarget || swipeTarget.dataset.swipeCloseBound) return;

            let startY = 0;
            let moveY = 0;
            let isDragging = false;

            swipeTarget.addEventListener('touchstart', (event) => {
                startY = event.touches[0].clientY;
                moveY = 0;
                isDragging = true;
                swipeTarget.style.transition = 'none';
            }, { passive: true });

            swipeTarget.addEventListener('touchmove', (event) => {
                if (!isDragging) return;

                moveY = event.touches[0].clientY - startY;
                if (moveY > 0) swipeTarget.style.transform = `translateY(${moveY}px)`;
            }, { passive: true });

            swipeTarget.addEventListener('touchend', () => {
                if (!isDragging) return;

                isDragging = false;
                swipeTarget.style.transition = 'transform 0.3s ease';

                if (moveY > 100) {
                    swipeTarget.style.transform = 'translateY(100%)';
                    setTimeout(() => closeFn(), 300);
                    return;
                }

                swipeTarget.style.transform = 'translateY(0)';
                setTimeout(() => resetLayerMotion(swipeTarget), 300);
            });

            swipeTarget.dataset.swipeCloseBound = 'true';
        };

        const resizeTextareas = (layerEl) => {
            requestAnimationFrame(() => {
                layerEl.querySelectorAll('textarea').forEach((textarea) => {
                    const resize = () => {
                        textarea.style.height = 'auto';
                        textarea.style.height = `${textarea.scrollHeight}px`;
                    };

                    if (!textarea.dataset.autoResize) {
                        textarea.addEventListener('input', resize);
                        textarea.dataset.autoResize = 'true';
                    }
                    resize();
                });
            });
        };

        const show = () => {
            const target = option.$target;
            if (!target) return;

            

            target.style.display = 'block';
            bodyEl.classList.add('ovf');

            const background = document.createElement('div');
            background.className = 'layer__bg close';
            target.appendChild(background);

            option.prevTarget = target;
            option.active = true;

            target.querySelectorAll('.close').forEach((closeButton) => {
                if (closeButton.dataset.layerCloseBound) return;
                closeButton.addEventListener('click', () => closeFn());
                closeButton.dataset.layerCloseBound = 'true';
            });

            bindSwipeClose(target);
            resizeTextareas(target);
            requestAnimationFrame(() => calendar.initFn(target));
        };

        const loadAndShow = async () => {
            if (!option.ajaxUrl) {
                show();
                return;
            }

            try {
                const response = await fetch(option.ajaxUrl);
                if (!response.ok) throw new Error('네트워크 오류가 발생했습니다.');

                const container = document.createElement('div');
                container.innerHTML = await response.text();

                const target = container.querySelector('.layer');
                const content = document.querySelector('.content');
                if (!target || !content) throw new Error('레이어를 표시할 영역을 찾지 못했습니다.');

                option.$target = target;
                option.ajaxCall = true;
                option.ajaxContainer = container;
                content.appendChild(container);
                show();
            } catch (error) {
                alert(error.message || error);
            }
        };

        const open = (newOption = {}) => {
            option = { ...defaultOption, ...newOption };
            option.$target = resolveElement(option.target);
            loadAndShow();
        };

        const openFn = (newOption = {}) => {
            if (option.active) {
                closeFn(() => open(newOption));
            } else {
                open(newOption);
            }
        };

        const applyFn = () => {
            document.querySelectorAll('.layer_btn').forEach((button) => {
                if (button.dataset.layerButtonBound) return;

                button.addEventListener('click', () => {
                    const layerName = button.dataset.layer;
                    const target = layerName ? document.querySelector(`.${layerName}`) : null;

                    if (!target) {
                        alert('호출할 레이어를 찾지 못했습니다.');
                        return;
                    }

                    openFn({ target });

                    if (typeof window.jQuery !== 'undefined' && jQuery.fn?.slick) {
                        jQuery('.slick-slider').slick('refresh');
                    }
                });

                button.dataset.layerButtonBound = 'true';
            });
        };

        return { applyFn, openFn, closeFn };
    })();

    window.layer = layer;
    layer.applyFn();

    document.querySelectorAll('[data-fullcalendar]').forEach((calendarEl) => {
        if (!calendarEl.closest('.layer')) calendar.initFn(calendarEl);
    });
});
